(() => {
  const longWeekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const longMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  function formatStrftime(date, fmt) {
    if (!fmt) return date.toLocaleDateString();
    const d = date.getDate();
    const m = date.getMonth();
    const y = date.getFullYear();
    const pad = (n) => (n < 10 ? '0' : '') + n;
    const map = new Map([
      ['%%', '%'],
      ['%A', longWeekdays[date.getDay()]],
      ['%a', longWeekdays[date.getDay()].slice(0, 3)],
      ['%B', longMonths[m]],
      ['%b', shortMonths[m]],
      ['%d', pad(d)],
      ['%e', String(d)],
      ['%m', pad(m + 1)],
      ['%Y', String(y)],
      ['%y', String(y).slice(-2)],
    ]);
    let s = fmt.replace(/%%/g, '\x00ESC\x00');
    map.forEach((val, key) => {
      if (key === '%%') return;
      s = s.split(key).join(val);
    });
    return s.replace(/\x00ESC\x00/g, '%');
  }

  function startOfTodayLocal() {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
  }

  function addDaysLocal(date, days) {
    const x = new Date(date.getTime());
    x.setDate(x.getDate() + Number(days));
    return x;
  }

  function parseRules(str) {
    try {
      const parsed = JSON.parse(str || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function optionValues(variant) {
    if (!variant) return [];
    return [variant.option1, variant.option2, variant.option3].filter((v) => v != null && String(v).trim() !== '');
  }

  function matches(values, needle, mode) {
    const n = String(needle || '').trim().toLowerCase();
    if (!n) return false;
    return values.some((raw) => {
      const o = String(raw).trim().toLowerCase();
      return mode === 'contains' ? o.includes(n) : o === n;
    });
  }

  function resolveRange(baseFrom, baseTo, rules, variant, mode) {
    const bf = Number(baseFrom) || 0;
    const bt = Number(baseTo) || 0;
    const baseFromN = Math.min(bf, bt);
    const baseToN = Math.max(bf, bt);
    const matched = [];
    for (let i = 0; i < rules.length; i++) {
      const r = rules[i];
      if (!r || r.m == null || r.m === '') continue;
      if (!matches(optionValues(variant), r.m, mode)) continue;
      let tf = r.f != null && r.f !== '' ? parseInt(r.f, 10) : NaN;
      let tt = r.t != null && r.t !== '' ? parseInt(r.t, 10) : NaN;
      if (Number.isNaN(tf)) tf = baseFromN;
      if (Number.isNaN(tt)) tt = baseToN;
      if (tf > tt) {
        const x = tf;
        tf = tt;
        tt = x;
      }
      matched.push({ from: tf, to: tt });
    }
    if (matched.length === 0) {
      return { from: baseFromN, to: baseToN };
    }
    let minFrom = matched[0].from;
    let maxTo = matched[0].to;
    for (let j = 1; j < matched.length; j++) {
      minFrom = Math.min(minFrom, matched[j].from);
      maxTo = Math.max(maxTo, matched[j].to);
    }
    if (maxTo < minFrom) maxTo = minFrom;
    return { from: minFrom, to: maxTo };
  }

  function updateBar(el, variant) {
    const valueEl = el.querySelector('.friendly-shipping__value');
    const df = parseInt(el.dataset.fsDaysFrom, 10);
    const dt = parseInt(el.dataset.fsDaysTo, 10);
    const rules = parseRules(el.dataset.fsRules);
    const mode = el.dataset.fsMatchMode || 'exact';
    const fmt = el.dataset.fsDateFormat || '%b %d';
    const sep = el.dataset.fsSeparator != null ? el.dataset.fsSeparator : ' – ';
    const range = resolveRange(df, dt, rules, variant, mode);
    let daysFrom = range.from;
    let daysTo = range.to;
    if (daysTo < daysFrom) daysTo = daysFrom;
    const base = startOfTodayLocal();
    const fromD = addDaysLocal(base, daysFrom);
    const toD = addDaysLocal(base, daysTo);
    const rendered = formatStrftime(fromD, fmt) + sep + formatStrftime(toD, fmt);
    if (valueEl) valueEl.textContent = rendered;
    if (el.dataset.fsCheckout === 'true') {
      syncCheckoutProperty(el, rendered);
    }
  }

  function findProductForms(el) {
    const scopes = [];
    const pinfo = el.closest('product-info');
    if (pinfo) scopes.push(pinfo);
    const section = el.closest('.shopify-section');
    if (section && !scopes.includes(section)) scopes.push(section);
    const forms = new Set();
    scopes.forEach((scope) => {
      scope.querySelectorAll('form[action*="/cart/add"]').forEach((f) => forms.add(f));
    });
    if (forms.size === 0) {
      document.querySelectorAll('form[action*="/cart/add"]').forEach((f) => forms.add(f));
    }
    return Array.from(forms);
  }

  function syncCheckoutProperty(el, value) {
    const label = (el.dataset.fsCheckoutLabel || 'Estimated Delivery').trim();
    if (!label) return;
    const inputName = 'properties[' + label + ']';
    const forms = findProductForms(el);
    forms.forEach((form) => {
      let input = form.querySelector('input[data-fs-checkout-input="true"][name="' + inputName.replace(/"/g, '\\"') + '"]');
      if (!input) {
        form.querySelectorAll('input[data-fs-checkout-input="true"]').forEach((old) => {
          if (old.name !== inputName) old.remove();
        });
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = inputName;
        input.setAttribute('data-fs-checkout-input', 'true');
        form.appendChild(input);
      }
      input.value = value;
    });
  }

  function bindBar(el) {
    if (el.dataset.fsBound === 'true') return;
    el.dataset.fsBound = 'true';
    const sectionId = el.dataset.fsSectionId;
    const sync = (variant) => {
      if (variant) {
        updateBar(el, variant);
        return;
      }
      const pinfo = el.closest('product-info') || document.querySelector(`product-info[data-section="${sectionId}"]`);
      if (pinfo) {
        const raw = pinfo.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        if (raw) {
          try {
            updateBar(el, JSON.parse(raw));
            return;
          } catch (_) {}
        }
      }
      updateBar(el, null);
    };
    el._fsSync = sync;
    sync(null);
  }

  function scan() {
    document
      .querySelectorAll(
        '.friendly-shipping[data-fs-dynamic="true"], .friendly-shipping[data-fs-checkout="true"]'
      )
      .forEach(bindBar);
  }

  function initPubsub() {
    if (window.__friendlyShippingPubsubInit) return;
    window.__friendlyShippingPubsubInit = true;
    if (typeof FoxTheme === 'undefined' || !FoxTheme.pubsub) return;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (ev) => {
      const sid = ev?.data?.sectionId;
      const variant = ev?.data?.variant;
      document
        .querySelectorAll(
          '.friendly-shipping[data-fs-dynamic="true"], .friendly-shipping[data-fs-checkout="true"]'
        )
        .forEach((el) => {
          if (String(el.dataset.fsSectionId) !== String(sid)) return;
          updateBar(el, variant);
        });
    });
  }

  function boot() {
    initPubsub();
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
